export function createGitApi(client) {
    return {
        connect(input) {
            return client.post('/api/git/connect', input);
        },
        status() {
            return client.get('/api/git/status');
        },
        sync() {
            return client.post('/api/git/sync');
        },
        diff() {
            return client.get('/api/git/diff');
        },
        push(message) {
            return client.post('/api/git/push', { message: message || '' });
        },
        conflicts() {
            return client.get('/api/git/conflicts');
        },
        resolve(file, choice) {
            return client.post('/api/git/resolve', { file, choice });
        },
        abort() {
            return client.post('/api/git/abort');
        },
    };
}
//# sourceMappingURL=git.js.map